import { ExpressionRuleEditor } from "../ExpressionRuleEditor";
import { BracketedDiv, ExpressionPiece } from "../../Builder/ExpressionStyles";
import { ExpressionValueRenderer } from "../../Builder/ExpressionValueRenderer";
import React from "react";
import { StringUppercaseExpression } from "../../../rule-engine-core/Expressions/Expressions/String/StringUppercaseExpression";

export class StringUppercaseExpressionEditor extends ExpressionRuleEditor<StringUppercaseExpression> {
    render() {
        return (
            <>
                <ExpressionPiece>
                    <BracketedDiv>
                        <ExpressionValueRenderer el={this.ruleData!.value1!} />
                    </BracketedDiv>
                    <ExpressionPiece>to upper case</ExpressionPiece>
                </ExpressionPiece>
            </>
        );
    }
}
